
module.exports = { 
      attributes: {},
    
      body: "<div style=\"width: 100%; text-align: center;\">\n  <imgasset style=\"margin: 40px auto; max-height: 100px;\" srcId=\"logo\" />\n</div>\n\n<br />\n\n---\n\n<br />\n\n<navlink to=\"/search\" style=\"margin-right: 1rem;\">Information & Services</navlink>\n<navlink to=\"/about\">About</navlink>\n",
    
      meta: {"resourcePath":"/home/vsts/work/1/s/src/tenants/nqphn/content/static/default/home.md"},
     }